import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ spacing }) => css`
    width: 100%;
    padding: 0 ${spacing.xs};
  `,

  bannerContainer: ({ spacing }) => css`
    max-width: calc(1280px - ${spacing.lg});
    margin: 0 auto;
  `,

  alertContainer: ({ spacing }) => css`
    max-width: calc(1280px - ${spacing.lg});
    margin: 0 auto;
    padding-top: ${spacing.xs};
  `,
})

export default useStyles
